import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CitasService {

  gCalendar: string = `${environment.apiCitas.context}${environment.apiCitas.methods.create}`;
  urlCatalogos: string = `${environment.apiCitas.context}${environment.apiCitas.methods.catalog}`;
  urlHorariosByFecha: string = `${environment.apiCitas.context}${environment.apiCitas.methods.hourByDate}`;
  urlResumenCitas: string =`${environment.apiCitas.context}${environment.apiCitas.methods.summary}`;
  urlStatusUpdate: string = `${environment.apiCitas.context}${environment.apiCitas.methods.status}`;

  constructor(private http: HttpClient) {
  }

  createEvent(request: any): Promise<any> {
    return this.http.post<any>(this.gCalendar, request).toPromise();
  }

  getCatalogo(): Promise<any> {
    const requestOptions = { headers: new HttpHeaders({ 'content-type': "application/json" }) };
    return this.http.get<any>(this.urlCatalogos, requestOptions ).toPromise();
  }

  getHorarios(request: any): Promise<any> {
    return this.http.post<any>(this.urlHorariosByFecha, request).toPromise();
  }

  getResumenCitas(): Promise<any> {
    const requestOptions = { headers: new HttpHeaders({ 'content-type': "application/json" }) };
    return this.http.get<any>(this.urlResumenCitas, requestOptions).toPromise();
  }

  updateStatus(request: any): Promise<any> {
    return this.http.post<any>(this.urlStatusUpdate, request).toPromise();
  }
}
